export const RESERVED_EVENTS = [
    "session_request",
    "session_update",
    "exchange_key",
    "connect",
    "disconnect",
    "display_uri",
    "modal_closed",
    "transport_open",
    "transport_close",
    "transport_error",
];
export const reservedEvents = RESERVED_EVENTS;
//# sourceMappingURL=events.js.map